import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class AccountsApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {}

  getDomainsList<T>(clientCode: string): Observable<T> {
    const query = new URLSearchParams({
      clientCode,
      module: 'JobPageAgent',
    });
    const url = `${this.configService.getBffUrl(
      'accounts',
      'v2/integration/clientdomains'
    )}?${query.toString()}`;
    return this.http.get<T>(url);
  }
}
